import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";

const Navbar = () => {
  const { scrollY } = useScroll();
  
  // Sticky until you scroll past hero (500px), then scrolls away (-100px)
  const navY = useTransform(scrollY, [0, 500, 1000], [0, 0, -100]);

  return (
    <motion.header
      className="sticky top-0 left-0 right-0 z-50 px-6 py-6 border-b border-black/5 bg-background"
      style={{ y: navY }}
    >
      <div className="w-full flex items-center justify-between">
        <Link to="/">
          <span className="font-funnel font-bold text-3xl text-foreground">
            qwip
          </span>
        </Link>

        <a 
          href="#partner-section"
          className="px-4 sm:px-6 py-2.5 border border-foreground/20 rounded-full font-medium text-sm hover:bg-muted active:scale-95 transition-all"
        >
          Become a Partner
        </a>
      </div>
    </motion.header>
  );
};

export default Navbar;
